import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import auth from '@/auth';
import store from '@/store';

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/login',
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/team',
    name: 'Team',
    component: DefaultLayout,
    redirect: '/team/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'Team Dashboard',
        component: () => import('@/views/team/Dashboard.vue'),
        meta: { page_id: 1 }
      },
      {
        path: 'clients',
        name: 'Team Pregled accountov',
        component: () => import('@/views/team/Clients.vue'),
        meta: { page_id: 2 }
      },
      {
        path: 'client/:id',
        name: 'Team Account',
        component: () => import('@/views/team/Client.vue'),
        meta: { page_id: 2 }
      },
      {
        path: 'brainstormings',
        name: 'Team Brainstormingi',
        component: () => import('@/views/team/Brainstormings.vue'),
        meta: { page_id: 3 }
      },
      {
        path: 'brainstorming/:id',
        name: 'Team Brainstorming',
        component: () => import('@/views/team/Brainstorming.vue'),
        meta: { page_id: 3 }
      },
      {
        path: 'scenes',
        name: 'Team Scenariji',
        component: () => import('@/views/team/Scenes.vue'),
        meta: { page_id: 4 }
      },
      {
        path: 'posts',
        name: 'Team Plani objav',
        component: () => import('@/views/team/Posts.vue'),
        meta: { page_id: 5 }
      },
      {
        path: 'productions',
        name: 'Team Produkcije',
        component: () => import('@/views/team/Productions.vue'),
        meta: { page_id: 17 }
      },
      {
        path: 'production/:id',
        name: 'Team Produkcija',
        component: () => import('@/views/team/Production.vue'),
        meta: { page_id: 17 }
      },
      {
        path: 'reports',
        name: 'Team Reports',
        component: () => import('@/views/team/Reports.vue'),
        meta: { page_id: 19 }
      },
      {
        path: 'report/:id',
        name: 'Team Report',
        component: () => import('@/views/team/Report.vue'),
        meta: { page_id: 19 }
      },
      {
        path: 'analytics/:id',
        name: 'Team Analytics',
        component: () => import('@/views/team/Analytics.vue'),
        meta: { page_id: 18 }
      },
      {
        path: 'anl-goals/:id',
        name: 'Team Analytics Goals',
        component: () => import('@/views/team/AnlGoals.vue'),
        meta: { page_id: 21 }
      },
      {
        path: 'influencers',
        name: 'Team Vplivneži',
        component: () => import('@/views/shared/Influencers.vue'),
        meta: { page_id: 6 }
      },
      {
        path: 'brands',
        name: 'Team Znamke',
        component: () => import('@/views/shared/Brands.vue'),
        meta: { page_id: 7 }
      },
      {
        path: 'users',
        name: 'Team Uporabniki',
        component: () => import('@/views/team/Users.vue'),
        meta: { page_id: 8 }
      },
      {
        path: 'accounting',
        name: 'Team Accounting',
        component: () => import('@/views/team/Accounting.vue'),
        meta: { page_id: 26 }
      },
      {
        path: 'team-accounts',
        name: 'Team Team Accounts',
        component: () => import('@/views/team/TeamAccounts.vue'),
        meta: { page_id: 27 }
      },
      {
        path: 'worktime',
        name: 'Team Worktime',
        component: () => import('@/views/team/Worktime.vue'),
        meta: { page_id: 29 }
      },
      {
        path: 'personal-finances',
        name: 'Team Personal Finances',
        component: () => import('@/views/team/PersonalFinances.vue'),
        meta: { page_id: 20 }
      },
      {
        path: 'verify/productions',
        name: 'Verify Productions',
        component: () => import('@/views/team/verify/VerifyProductions.vue'),
        meta: { page_id: 23 }
      },
      {
        path: 'verify/production/:id',
        name: 'Verify Production',
        component: () => import('@/views/team/Production.vue'),
        meta: { page_id: 23 }
      },
      {
        path: 'verify/reports',
        name: 'Verify Reports',
        component: () => import('@/views/team/Reports.vue'),
        meta: { page_id: 24 }
      },
      {
        path: 'verify/report/:id',
        name: 'Verify Report',
        component: () => import('@/views/team/Report.vue'),
        meta: { page_id: 24 }
      },
      {
        path: 'verify/scenes',
        name: 'Verify Scenes',
        component: () => import('@/views/team/Scenes.vue'),
        meta: { page_id: 25 }
      },
      {
        path: 'verify/posts',
        name: 'Verify Posts',
        component: () => import('@/views/team/Posts.vue'),
        meta: { page_id: 28 }
      }
    ],
  },
  {
    path: '/clients',
    name: 'Clients',
    component: DefaultLayout,
    redirect: '/clients/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/clients/dashboard',
        name: 'Client Dashboard',
        component: () => import('@/views/clients/Dashboard.vue'),
        meta: { page_id: 14 }
      },
      {
        path: 'scenes',
        name: 'Client Scenes',
        component: () => import('@/views/clients/Scenes.vue'),
        meta: { page_id: 15 }
      },
      {
        path: 'posts',
        name: 'Client Posts',
        component: () => import('@/views/clients/Posts.vue'),
        meta: { page_id: 16 }
      },
      {
        path: 'results',
        name: 'Client Results',
        component: () => import('@/views/clients/Results.vue'),
        meta: { page_id: 22 }
      },
      {
        path: 'brands',
        name: 'Client Brands',
        component: () => import('@/views/shared/Brands.vue'),
        meta: { page_id: 14 }
      }
    ]
  },
  {
    path: '/',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    meta: { allUsers: true },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
        meta: { guestOnly: true }
      },
      {
        path: 'register/:token',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
        meta: { guestOnly: true }
      },
    ],
  },
  {
    path: '/reports',
    name: 'Reports',
    meta: { allUsers: true },
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '/reports/accounts/:type/:limit',
        name: 'AccountsReport',
        component: () => import('@/reports/Accounts.vue'),
      },
      {
        path: '/reports/account/:id',
        name: 'AccountReport',
        component: () => import('@/reports/Account.vue'),
      }
    ]
  },
  {
    path: "/:catchAll(.*)",
    name: "Page not found",
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to,from,next) => {
  auth.userPromise.then(() => {
    let currentUser = store.state.user;
    let requireAuth = to.matched.some(record => record.meta.requiresAuth);
    let guestOnly = to.matched.some(record => record.meta.guestOnly);

    if (requireAuth && !currentUser) {
      next('/login');
    } else if (guestOnly && currentUser) {
      // chech what the user is
      if (currentUser.team) {
        next('/team');
      } else if (currentUser.client) {
        next('/clients/dashboard');
      } else if (currentUser.influencer) {
        next('/influencers/dashboard');
      } else {
        // unknown user type
        console.log('unknown user type');
        next('/404');
      }
    } else {
      if (currentUser) {
        if (to.matched.some(record => currentUser.privileges.includes(record.meta.page_id) || record.meta.allUsers)) next();
        else next('/404');
      } else {
        next()
      }
    }
  })
})

export default router
